$(document).ready(function() {

  // ===== ВСПОМОГАТЕЛЬНЫЕ ФУНКЦИИ =====
  function isMobile() {
    return window.innerWidth <= 480;
  }

  function canHandleHover() {
    return !isMobile();
  }

  var EXPANDABLE_INNER = '.product-grid:not(.module-style3) .product-thumb .item-inner';

  function titleClampLines() {
    var n = parseInt((window.getComputedStyle(document.documentElement).getPropertyValue('--title-line-clamp') || '').trim(), 10);
    return (n === 1 || n === 2) ? String(n) : '2';
  }

  function applyClamp(el) {
    if (!el) return;
    el.style.setProperty('display', '-webkit-box');
    el.style.setProperty('-webkit-line-clamp', titleClampLines());
    el.style.setProperty('-webkit-box-orient', 'vertical');
    el.style.setProperty('overflow', 'hidden');
  }

  function removeClamp(el) {
    if (!el) return;
    el.style.setProperty('display', 'block');
    el.style.removeProperty('-webkit-line-clamp');
    el.style.setProperty('overflow', 'visible');
  }

  function updateClampState() {
    $(EXPANDABLE_INNER + ' .product-name a')
      .not('.skeleton-item .item-inner .product-name a')
      .each(function() {
        applyClamp(this);
      });
  }

  // ===== ИЗМЕРЕНИЕ ВЫСОТ =====
  var suppressSlotLock = false;
  var slotLockTimer = null;
  var SLOT_LOCK_DELAY_MS = 1050;

  // Exact (fractional) height: min-height accepts it. Math.ceil here made a locked row up to 1px taller
  // than the free ones next to it, so rows/columns below shifted on the first hover.
  function boxHeight($el) {
    if (!$el || !$el.length || !$el[0].getBoundingClientRect) return 0;
    return $el[0].getBoundingClientRect().height;
  }

  // Open or closing card: measuring/clearing it would drop it out of its reserved slot under the cursor.
  function isCardBusy($inner) {
    return $inner.hasClass('card-expanded') || $inner.hasClass('is-fading');
  }

  function captureSlot($inner) {
    if (!$inner || !$inner.length) return;
    if ($inner.hasClass('card-expanded') || $inner.hasClass('is-fading')) return;

    var $thumb = $inner.closest('.product-thumb');
    var $layout = $inner.closest('.product-layout');
    var $item = $inner.closest('.item');

    $inner.data('original-height', boxHeight($inner));
    $inner.data('slot-height', boxHeight($thumb));
    $layout.data('original-layout-height', boxHeight($layout));
    if ($item.length) $item.data('slot-height', boxHeight($item));
  }

  // force: an expanding card always reserves its slot, even while background locking is suppressed
  // (resize / grid refresh), otherwise it goes absolute with nothing holding its place and the row below jumps up.
  function reserveSlot($inner, force) {
    if (suppressSlotLock && !force) return;
    if (!$inner || !$inner.length) return;

    captureSlot($inner);

    var $thumb = $inner.closest('.product-thumb');
    var $layout = $inner.closest('.product-layout');
    var $item = $inner.closest('.item');
    var slot = $inner.data('slot-height');
    var layoutSlot = $layout.data('original-layout-height');
    var itemSlot = $item.data('slot-height');

    if (slot) $thumb.css('min-height', slot + 'px');
    if (layoutSlot) $layout.css('min-height', layoutSlot + 'px');
    if (itemSlot) $item.css('min-height', itemSlot + 'px');
  }

  function lockRowSlots($inner, force) {
    var $layout = $inner.closest('.product-layout');
    var $container = $layout.parent();
    if (!$container.length) return;

    var rowTop = $layout.offset().top;

    $container.children('.product-layout.product-grid').each(function() {
      var $col = $(this);
      if (Math.abs($col.offset().top - rowTop) > 3) return;
      reserveSlot($col.find('.item-inner').first(), force);
    });
  }

  function clearSlotLocks() {
    suppressSlotLock = true;
    $(EXPANDABLE_INNER)
      .not('.skeleton-item .item-inner')
      .each(function() {
        var $inner = $(this);
        if (isCardBusy($inner)) return;
        var $thumb = $inner.closest('.product-thumb');
        var $layout = $inner.closest('.product-layout');
        var $item = $inner.closest('.item');
        $inner.css('height', '');
        $thumb.css('min-height', '');
        $layout.css('min-height', '');
        $item.css('min-height', '');
        $inner.removeData('slot-height');
        $inner.removeData('original-height');
        $layout.removeData('original-layout-height');
        $item.removeData('slot-height');
      });
  }

  function lockAllClosedSlots() {
    if (isMobile()) {
      clearSlotLocks();
      return;
    }
    suppressSlotLock = false;
    $(EXPANDABLE_INNER)
      .not('.skeleton-item .item-inner')
      .each(function() {
        var $inner = $(this);
        if (isCardBusy($inner)) return;
        // Drop this card's old locks first: a card that was open during a resize still holds the old size.
        $inner.closest('.product-thumb').css('min-height', '');
        $inner.closest('.product-layout').css('min-height', '');
        $inner.closest('.item').css('min-height', '');
        captureSlot($inner);
        reserveSlot($inner);
      });
  }

  function scheduleSlotLock() {
    clearTimeout(slotLockTimer);
    suppressSlotLock = true;
    slotLockTimer = setTimeout(lockAllClosedSlots, SLOT_LOCK_DELAY_MS);
  }

  function measureExpandedHeight($inner, keepUnclamped) {
    var $boxHover = $inner.find('.box-hover');
    var $caption = $inner.find('.caption');
    var $nameLink = $inner.find('.product-name a');
    var $price = $inner.find('.caption .price-box');

    $inner.addClass('is-measuring');

    if ($nameLink.length) {
      removeClamp($nameLink[0]);
      void $nameLink[0].offsetHeight;
    }

    $price.css({
      'position': 'absolute',
      'height': '0',
      'overflow': 'hidden',
      'visibility': 'hidden',
      'margin': '0'
    });

    $boxHover.css({
      'position': 'relative',
      'visibility': 'hidden',
      'opacity': '0',
      'top': 'auto',
      'left': 'auto',
      'right': 'auto',
      'margin-top': '0'
    });
    void $caption[0].offsetHeight;

    var imgHeight = $inner.find('.images-container').outerHeight();
    var captionFullHeight = $caption.outerHeight();

    $price.css({
      'position': '',
      'height': '',
      'overflow': '',
      'visibility': '',
      'margin': ''
    });

    $boxHover.css({
      'position': '',
      'visibility': '',
      'opacity': '',
      'top': '',
      'left': '',
      'right': '',
      'margin-top': ''
    });

    if (!keepUnclamped) {
      $inner.removeClass('is-measuring');
      if ($nameLink.length) {
        applyClamp($nameLink[0]);
        void $nameLink[0].offsetHeight;
      }
    }

    var totalHeight = Math.ceil((imgHeight || 0) + (captionFullHeight || 0));
    $inner.data('hover-height', totalHeight);
    $inner[0].style.setProperty('--hover-height', totalHeight + 'px');
    return totalHeight;
  }

  function measureHeightsCore() {
    $(EXPANDABLE_INNER)
      .not('.skeleton-item .item-inner')
      .each(function() {
        var $inner = $(this);
        if (isCardBusy($inner) && !isMobile()) return;
        var $layout = $inner.closest('.product-layout');
        var $thumb = $inner.closest('.product-thumb');

        var $item = $inner.closest('.item');
        $inner.removeClass('card-expanded is-fading is-measuring');
        $inner.css('height', '');
        $thumb.css('min-height', '');
        $layout.css('min-height', '');
        $item.css('min-height', '');
        $layout.removeClass('is-card-active is-card-fading is-card-waiting');
        $item.removeData('slot-height');
        $inner.removeData('original-height');
        $inner.removeData('slot-height');
        $layout.removeData('original-layout-height');

        if (!isMobile()) {
          measureExpandedHeight($inner, false);
          if (!suppressSlotLock) {
            captureSlot($inner);
            reserveSlot($inner);
          }
        }
      });
  }

  function measureHeights() {
    measureHeightsCore();
    revealGrid();
  }

  function recalcHeightsOnly() {
    measureHeightsCore();
  }

  function initClamp() {
    $(EXPANDABLE_INNER + ' .product-name a')
      .not('.skeleton-item .item-inner .product-name a')
      .each(function() {
        applyClamp(this);
      });
  }

  // ===== АНИМАЦИЯ ПОЯВЛЕНИЯ СЕТКИ =====
  var ENTRANCE_MS = 1000;
  var entranceUnlockTimer = null;

  function lockGridEntrance() {
    $('body').addClass('grid-entering');
    clearTimeout(entranceUnlockTimer);
  }

  function unlockGridEntrance() {
    clearTimeout(entranceUnlockTimer);
    entranceUnlockTimer = setTimeout(function() {
      $('body').removeClass('grid-entering');
    }, ENTRANCE_MS + 80);
  }

  function revealGrid() {
    // A late window.load (heavy page) must not replay the entrance over a grid the user is already using.
    if ($('body').hasClass('grid-loaded')) return;
    lockGridEntrance();
    $('body').addClass('grid-ready');

    setTimeout(function() {
      $('body').addClass('grid-loaded');

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          $('body').addClass('entrance-play');
          unlockGridEntrance();
        });
      });
    }, 500);
  }

  // ===== ПРИНУДИТЕЛЬНОЕ ЗАКРЫТИЕ =====
  var FADE_MS = 300;
  var LEAVE_DELAY_MS = 100;

  function clearCollapseTimer($inner) {
    var timer = $inner.data('collapse-timer');
    if (timer) {
      clearTimeout(timer);
      $inner.removeData('collapse-timer');
    }
  }

  function clearLeaveTimer($inner) {
    var timer = $inner.data('leave-timer');
    if (timer) {
      clearTimeout(timer);
      $inner.removeData('leave-timer');
    }
  }

  function scheduleCollapse($inner) {
    if (!$inner || !$inner.length) return;
    if ($inner.hasClass('is-fading')) return;
    if (!$inner.hasClass('card-expanded') && !$inner.data('is-hovered')) return;
    if ($inner.data('leave-timer')) return;

    $inner.data('leave-timer', setTimeout(function() {
      $inner.removeData('leave-timer');
      collapseCard($inner);
    }, LEAVE_DELAY_MS));
  }

  function finishCollapse($inner) {
    if (!$inner || !$inner.length) return;

    var shouldReopen = $inner.data('reopen') && $inner.data('pointer-inside');
    $inner.removeData('reopen');

    clearCollapseTimer($inner);
    clearLeaveTimer($inner);

    var $nameLink = $inner.find('.product-name a');
    if ($nameLink.length) {
      applyClamp($nameLink[0]);
    }

    $inner.removeData('is-hovered');
    $inner.removeClass('card-expanded is-fading force-closed is-measuring');
    $inner.css('height', '');
    $inner.closest('.product-layout').removeClass('is-card-active is-card-fading is-card-waiting');

    if (shouldReopen) {
      expandCard($inner);
    }
  }

  function forceCloseAllCards() {
    $(EXPANDABLE_INNER)
      .not('.skeleton-item .item-inner')
      .each(function() {
        finishCollapse($(this));
      });
  }

  // Grid refresh keeps the card under the cursor open (filter.js reuses its node); everything else closes.
  function closeIdleCards() {
    $(EXPANDABLE_INNER)
      .not('.skeleton-item .item-inner')
      .each(function() {
        var $inner = $(this);
        if ($inner.data('pointer-inside') && $inner.hasClass('card-expanded') && !$inner.hasClass('is-fading')) return;
        finishCollapse($inner);
      });
  }

  function forceCloseCard($card) {
    if (!$card || !$card.length) return;

    clearCollapseTimer($card);
    clearLeaveTimer($card);
    $card.addClass('force-closed');
    $card.removeClass('card-expanded is-fading is-measuring');

    var $nameLink = $card.find('.product-name a');
    if ($nameLink.length) {
      applyClamp($nameLink[0]);
    }

    var el = $card[0];
    el.style.removeProperty('height');
    el.style.removeProperty('min-height');
    el.style.removeProperty('max-height');
    el.style.removeProperty('position');
    el.style.removeProperty('left');
    el.style.removeProperty('right');
    el.style.removeProperty('z-index');

    $card.removeData('is-hovered');
    $card.removeData('reopen');
    $card.closest('.product-layout').removeClass('is-card-active is-card-waiting').addClass('is-card-fading');
  }

  function isCarouselEntranceLocked($inner) {
    var $mod = $inner.closest('.has-carousel-skeleton');
    if (!$mod.length) return false;
    if ($mod.hasClass('list-style') || $mod.hasClass('module-footer')) return false;
    if ($mod.hasClass('carousel-sk-entering')) return true;
    if (!$mod.hasClass('carousel-sk-play')) return true;
    return false;
  }

  function expandCard($inner) {
    if (!$inner || !$inner.length) return;
    if (!canHandleHover()) return;
    if ($('body').hasClass('grid-entering')) return;
    if (isCarouselEntranceLocked($inner)) return;
    if (isDragging || $('body').hasClass('is-card-dragging')) return;
    if (Date.now() < ignoreHoverUntil) return;
    if ($inner.hasClass('force-closed')) return;

    if ($inner.hasClass('card-expanded') && !$inner.hasClass('is-fading')) {
      clearLeaveTimer($inner);
      $inner.data('is-hovered', true);
      return;
    }

    if ($inner.hasClass('is-fading')) {
      $inner.data('reopen', true);
      return;
    }

    lockRowSlots($inner, true);

    $(EXPANDABLE_INNER + '.card-expanded').not($inner).each(function() {
      $(this).closest('.product-layout')
        .removeClass('is-card-active')
        .addClass('is-card-waiting');
    });

    clearLeaveTimer($inner);
    clearCollapseTimer($inner);
    $inner.removeClass('is-fading');
    $inner.closest('.product-layout').removeClass('is-card-fading is-card-waiting').addClass('is-card-active');

    reserveSlot($inner, true);

    $inner.data('is-hovered', true);

    var totalHeight = measureExpandedHeight($inner, true);
    if (!totalHeight) {
      $inner.removeClass('is-measuring');
      return;
    }

    $inner.css('height', totalHeight + 'px');
    $inner.removeClass('is-measuring').addClass('card-expanded');
  }

  function collapseCard($inner) {
    if (!$inner || !$inner.length) return;
    clearLeaveTimer($inner);
    if ($inner.hasClass('is-fading')) return;

    if (!$inner.hasClass('card-expanded') && !$inner.data('is-hovered')) {
      finishCollapse($inner);
      return;
    }

    $inner.removeData('is-hovered');
    $inner.addClass('is-fading');
    $inner.closest('.product-layout').removeClass('is-card-active is-card-waiting').addClass('is-card-fading');

    var $nameLink = $inner.find('.product-name a');
    var closedHeight = $inner.data('original-height');

    if ($nameLink.length) applyClamp($nameLink[0]);
    if (closedHeight) $inner.css('height', closedHeight + 'px');

    $inner.data('collapse-timer', setTimeout(function() {
      finishCollapse($inner);
    }, FADE_MS));
  }

  // ===== РЕСАЙЗ =====
  function resetHorizontalScroll() {
    window.scrollTo(0, window.scrollY || window.pageYOffset || 0);
    document.documentElement.scrollLeft = 0;
    document.body.scrollLeft = 0;
    var cat = document.getElementById('product-category');
    if (cat) cat.scrollLeft = 0;
    var products = document.getElementById('custom-products');
    if (products) products.scrollLeft = 0;
  }

  function handleResize() {
    void document.body.offsetHeight;
    if (isMobile()) {
      forceCloseAllCards();
      clearSlotLocks();
    }
    updateClampState();
    recalcHeightsOnly();
    resetHorizontalScroll();
  }

  // ===== ОТСЛЕЖИВАНИЕ ПЕРЕТАСКИВАНИЯ =====
  var isDragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragThreshold = 6;
  var ignoreHoverUntil = 0;
  var $draggedCard = null;

  var touchState = {
    $card: null,
    x: 0,
    y: 0,
    moved: false,
    holdTimer: null
  };
  var lastTouchAt = 0;
  var TOUCH_HOLD_MS = 300;
  var TOUCH_GHOST_MS = 700;

  function clearTouchHoldTimer() {
    if (touchState.holdTimer) {
      clearTimeout(touchState.holdTimer);
      touchState.holdTimer = null;
    }
  }

  function isGhostMouseFromTouch() {
    return lastTouchAt && Date.now() - lastTouchAt < TOUCH_GHOST_MS;
  }

  function isTouchExpandable($inner) {
    return $inner
      && $inner.length
      && $inner.hasClass('js-card-expand')
      && $inner.closest('.product-grid:not(.module-style3)').length > 0;
  }

  function isGhostMouseLeave($inner) {
    if (!$inner || !$inner.length || !$inner.hasClass('js-card-expand')) return false;
    if (touchState.$card && touchState.$card[0] === $inner[0]) return true;
    return isGhostMouseFromTouch();
  }

  function startDragTracking(e) {
    if (isMobile()) return;

    isDragging = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    $draggedCard = $(e.currentTarget);
  }

  function checkDrag(e) {
    if (isMobile() || !$draggedCard || isDragging) return;

    var dx = Math.abs(e.clientX - dragStartX);
    var dy = Math.abs(e.clientY - dragStartY);

    if (dx > dragThreshold || dy > dragThreshold) {
      isDragging = true;
      forceCloseCard($draggedCard);
      $('body').addClass('is-card-dragging');
    }
  }

  function endDragTracking() {
    if (isDragging) ignoreHoverUntil = Date.now() + 250;
    $('body').removeClass('is-card-dragging');

    if ($draggedCard && $draggedCard.length) {
      $draggedCard.one('mouseleave', function() {
        $(this).removeClass('force-closed');
      });
    }

    isDragging = false;
    $draggedCard = null;
  }

  // ===== HOVER ОБРАБОТЧИКИ =====
  $(document).on('mouseenter', EXPANDABLE_INNER + ':not(.skeleton-item .item-inner)', function() {
    var $inner = $(this);
    $inner.data('pointer-inside', true);
    if (isGhostMouseFromTouch()) return;
    if (Date.now() < ignoreHoverUntil) return;
    expandCard($inner);
  });

  $(document).on('mouseleave', EXPANDABLE_INNER + ':not(.skeleton-item .item-inner)', function() {
    if (!canHandleHover()) return;
    var $inner = $(this);
    $inner.data('pointer-inside', false);
    $inner.removeData('reopen');
    if (isGhostMouseLeave($inner)) return;
    scheduleCollapse($inner);
  });

  $(document).on('mouseleave', '.product-grid:not(.module-style3) .product-thumb', function() {
    if (isMobile()) return;

    var $inner = $(this).find('.item-inner');
    $inner.data('pointer-inside', false);
    $inner.removeData('reopen');
    if (isGhostMouseLeave($inner)) return;
    scheduleCollapse($inner);
  });

  $(document).on('mousedown click', '.js-card-expand .action-links, .js-card-expand .action-links button, .js-card-expand .action-links a, .js-card-expand .bquickview', function(e) {
    e.stopPropagation();
  });

  // ===== ПОДПИСКИ НА ПЕРЕТАСКИВАНИЕ =====
  $(document).on('mousedown', EXPANDABLE_INNER + ':not(.skeleton-item .item-inner)', function(e) {
    if (isMobile()) return;
    startDragTracking(e);
  });

  $(document).on('mousemove', function(e) {
    checkDrag(e);
  });

  $(document).on('mouseup', function() {
    endDragTracking();
  });

  $(document).on('drag.owl.carousel', function() {
    isDragging = true;
    $('body').addClass('is-card-dragging');
    $(EXPANDABLE_INNER + '.card-expanded').each(function() {
      forceCloseCard($(this));
    });
  });

  function restartOwlZoom(root) {
    $(root).find('.owl-item.active .product-thumb > .item').each(function() {
      var el = this;
      el.style.webkitAnimation = 'none';
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.webkitAnimation = '';
      el.style.animation = '';
    });
  }

  function endOwlDrag() {
    ignoreHoverUntil = Date.now() + 550;
    $('body').removeClass('is-card-dragging');
    isDragging = false;
    $draggedCard = null;
    $(EXPANDABLE_INNER).removeClass('force-closed is-measuring');
  }

  $(document).on('dragged.owl.carousel translated.owl.carousel', function() {
    endOwlDrag();
  });

  function waitForCarouselImages($carousel, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      done();
    }
    var imgs = $carousel.find('.owl-item.active img').toArray();
    if (!imgs.length) {
      finish();
      return;
    }
    var left = imgs.length;
    function one() {
      left -= 1;
      if (left <= 0) finish();
    }
    imgs.forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) one();
      else {
        img.addEventListener('load', one, { once: true });
        img.addEventListener('error', one, { once: true });
      }
    });
    setTimeout(finish, 5000);
  }

  function revealCarouselSkeleton($module, $carousel) {
    if (!$module || !$module.length) return;
    if ($module.data('sk-started')) return;
    if ($module.hasClass('list-style') || $module.hasClass('module-footer')) return;
    if ($module.find('> .product-list, .tt-product.product-list').length) return;
    $module.data('sk-started', true);

    var $container = $module.find('.owl-container').first();
    var started = Date.now();

    function lockSkeletonHeight() {
      var skH = $module.find('.carousel-skeleton').outerHeight();
      if (skH) $container.css('min-height', skH + 'px');
    }

    lockSkeletonHeight();

    waitForCarouselImages($carousel, function() {
      var wait = Math.max(0, 400 - (Date.now() - started));
      setTimeout(function() {
        lockSkeletonHeight();
        $module.addClass('carousel-sk-entering carousel-sk-ready');
        setTimeout(function() {
          $module.addClass('carousel-sk-loaded');
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              $module.addClass('carousel-sk-play');
              ignoreHoverUntil = Date.now() + ENTRANCE_MS;
              setTimeout(function() {
                $module.removeClass('carousel-sk-entering');
                $container.css('min-height', '');
              }, ENTRANCE_MS + 80);
            });
          });
        }, 500);
      }, wait);
    });
  }

  function tryRevealCarousel($carousel) {
    if (!$carousel || !$carousel.length) return;
    var $module = $carousel.closest('.has-carousel-skeleton');
    if (!$module.length) return;
    var $pane = $carousel.closest('.tab-pane');
    if ($pane.length && !$pane.hasClass('active') && !$pane.hasClass('in')) return;
    revealCarouselSkeleton($module, $carousel);
  }

  $(document).on('initialized.owl.carousel', function(e) {
    ignoreHoverUntil = Date.now() + 550;
    tryRevealCarousel($(e.target));
  });

  $('.has-carousel-skeleton .owl-carousel.owl-loaded').each(function() {
    tryRevealCarousel($(this));
  });

  $(document).on('shown.bs.tab', function(e) {
    ignoreHoverUntil = Date.now() + 550;
    var href = $(e.target).attr('href');
    if (href) restartOwlZoom(href);
  });

  // ===== TOUCH: раскрытие на hold; закрытие только тапом вне inner =====
  $(document).on('touchstart', '.js-card-expand', function(e) {
    if (!canHandleHover()) return;

    var $inner = $(this);
    if (!isTouchExpandable($inner)) return;

    var oe = e.originalEvent || e;
    var touches = oe.touches || oe.changedTouches;
    if (!touches || touches.length !== 1) return;

    var touch = touches[0];
    touchState.$card = $inner;
    touchState.x = touch.clientX;
    touchState.y = touch.clientY;
    touchState.moved = false;

    clearTouchHoldTimer();
    touchState.holdTimer = setTimeout(function() {
      touchState.holdTimer = null;
      if (!touchState.$card || touchState.moved) return;
      var $opened = touchState.$card;
      $('.js-card-expand.card-expanded').not($opened).each(function() {
        collapseCard($(this));
      });
      $opened.data('pointer-inside', true);
      expandCard($opened);
    }, TOUCH_HOLD_MS);
  });

  $(document).on('touchmove', function(e) {
    if (!canHandleHover() || !touchState.$card) return;

    var oe = e.originalEvent || e;
    var touch = oe.touches && oe.touches[0];
    if (!touch) return;

    var dx = Math.abs(touch.clientX - touchState.x);
    var dy = Math.abs(touch.clientY - touchState.y);

    if (dx > dragThreshold || dy > dragThreshold) {
      touchState.moved = true;
      clearTouchHoldTimer();
    }
  });

  $(document).on('touchend touchcancel', function(e) {
    var moved = touchState.moved;
    var isCancel = e.type === 'touchcancel';

    clearTouchHoldTimer();
    lastTouchAt = Date.now();
    $('body').removeClass('is-card-dragging');

    if (!moved && !isCancel) {
      var $hit = $(e.target).closest('.js-card-expand');
      if ($hit.length && !isTouchExpandable($hit)) $hit = $();

      $('.js-card-expand.card-expanded').each(function() {
        if (!$hit.length || this !== $hit[0]) {
          collapseCard($(this));
        }
      });
    }

    touchState.$card = null;
    touchState.moved = false;
  });

  // ===== БЛОКИРОВКА МЕНЮ / ВЫДЕЛЕНИЯ =====
  function blockMenuEvents(e) {
    if (e.target.closest && e.target.closest('.product-grid .product-thumb')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  document.addEventListener('contextmenu', blockMenuEvents, true);
  document.addEventListener('selectstart', blockMenuEvents, true);
  document.addEventListener('dragstart', blockMenuEvents, true);

  $(document).on('contextmenu selectstart dragstart',
    '.product-grid .product-thumb, .product-grid .product-thumb *',
    function(e) {
      e.preventDefault();
      return false;
    }
  );

  // ===== ОТКЛЮЧЕНИЕ ВЫДЕЛЕНИЯ =====
  function forceDisableSelection() {
    $('.product-grid .product-thumb, .product-grid .product-thumb *').each(function() {
      var el = this;
      el.style.userSelect = 'none';
      el.style.webkitUserSelect = 'none';
      el.style.mozUserSelect = 'none';
      el.style.msUserSelect = 'none';
      el.style.webkitTouchCallout = 'none';
      el.style.webkitUserDrag = 'none';

      if (el.tagName === 'A') {
        el.setAttribute('draggable', 'false');
      }
    });
  }

  // ===== ИНИЦИАЛИЗАЦИЯ =====
  initClamp();
  forceDisableSelection();

  function refreshGridMetrics() {
    closeIdleCards();
    initClamp();
    measureHeightsCore();
    forceDisableSelection();
    clearSlotLocks();
    scheduleSlotLock();
    observeGridHost();
  }

  $(document).on('grid:changed', function() {
    $('body').removeClass('grid-ready grid-loaded entrance-play is-card-dragging');
    lockGridEntrance();
    clearSlotLocks();
    scheduleSlotLock();

    setTimeout(function() {
      forceCloseAllCards();
      initClamp();
      measureHeightsCore();
      forceDisableSelection();

      setTimeout(function() {
        initClamp();
        measureHeightsCore();
        $('body').addClass('grid-ready');

        setTimeout(function() {
          $('body').addClass('grid-loaded');
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              $('body').addClass('entrance-play');
              unlockGridEntrance();
            });
          });
        }, 300);
      }, 80);
    }, 60);
  });

  $(document).on('grid:refreshed', function() {
    refreshGridMetrics();
  });

  $(window).on('load', function() {
    ImageSkeleton.init();
    initClamp();
    measureHeights();
  });

  var resizeTimer;

  function onGridWidthChange() {
    resetHorizontalScroll();
    clearSlotLocks();
    scheduleSlotLock();
    if (isMobile()) forceCloseAllCards();
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  }

  $(window).on('resize orientationchange', onGridWidthChange);

  var gridHostObserver = null;
  var lastGridWidth = 0;

  function observeGridHost() {
    if (!window.ResizeObserver) return;
    var host = document.getElementById('content') || document.querySelector('.custom-products');
    if (!host) return;
    lastGridWidth = host.clientWidth;
    if (gridHostObserver) gridHostObserver.disconnect();
    gridHostObserver = new ResizeObserver(function() {
      var w = host.clientWidth;
      if (Math.abs(w - lastGridWidth) < 2) return;
      lastGridWidth = w;
      onGridWidthChange();
    });
    gridHostObserver.observe(host);
  }

  observeGridHost();

  if (window.matchMedia) {
    var mobileMq = window.matchMedia('(max-width: 480px)');
    var onMobileMq = function() {
      resetHorizontalScroll();
      setTimeout(resetHorizontalScroll, 50);
    };
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onMobileMq);
    else if (mobileMq.addListener) mobileMq.addListener(onMobileMq);
  }

});